import React from "react";
import clsx from "clsx";
import { Button, Tabs, Tab, TabPanel } from "@curves/ui-base";

/**
 * 表單的步驟的純顯示元件。
 *
 * 不含任何狀態與業務判斷：現在第幾步、能不能換頁、資料怎麼收集，
 * 全部由呼叫端的 hook 決定後以 props 傳入。
 *
 * @param {Array}    steps           步驟清單 [{ id, label, content, hasError }]
 * @param {number}   currentStep     目前第幾步
 * @param {object}   contentRef      指向當前步驟元件的 ref，由 hook 提供
 * @param {Function} onStepChange    要換到第幾步時呼叫（含上一步／下一步）
 * @param {Function} onTemporary     暫存
 * @param {Function} onSubmit        確認送出
 * @param {Function} onCancel        取消
 * @param {Function} onReturnHistory 返回
 * @param {Element}  ButtonEls       額外按鈕插槽
 */
const DocumentStepper = ({
	steps = [],
	currentStep = 0,
	contentRef,
	onStepChange,
	onTemporary,
	onSubmit,
	onCancel,
	onReturnHistory,
	isTemporary = true,
	isSubmit = true,
	isCancel = true,
	isBack = false,
	tabsProps = {},
	tabsFooterProps = {},
	TabPanelProps = {},
	ButtonEls = null,
}) => {
	const isFirstStep = currentStep === 0;
	const isLastStep = currentStep === steps.length - 1;

	return (
		<React.Fragment>
			<Tabs className={clsx("document-stepper__tabs", tabsProps.className)} value={currentStep} onChange={(e, index) => onStepChange(index)}>
				{steps.map(({ id, label, hasError }, index) => (
					<Tab key={id} value={index} label={label} className={clsx({ state: hasError })} />
				))}
			</Tabs>
			{steps.map(({ id, content }, index) => (
				<TabPanel className={clsx("document-stepper__panel", TabPanelProps.className)} key={id} value={currentStep} index={index}>
					{React.cloneElement(content, { ref: contentRef })}
				</TabPanel>
			))}
			<div className={clsx("document-stepper__footer", tabsFooterProps.className)}>
				<div className="btn-group">
					{!isFirstStep && (
						<Button variant="outlined" color="secondary" className="btn-minWidth prev" onClick={() => onStepChange(currentStep - 1)}>
							上一步
						</Button>
					)}
					<div className="btn-group">
						{isCancel && (
							<Button color="secondary" className="btn-minWidth" onClick={onCancel}>
								取消
							</Button>
						)}
						{isTemporary && (
							<Button name="temporary" variant="contained" color="secondary" className="btn-minWidth" onClick={onTemporary}>
								暫存檔案
							</Button>
						)}
						{isSubmit && isLastStep && (
							<Button name="create" variant="contained" color="secondary" className="btn-minWidth" onClick={onSubmit}>
								確認送出
							</Button>
						)}
						{isBack && (
							<Button variant="contained" color="secondary" className="btn-minWidth" onClick={onReturnHistory}>
								返回
							</Button>
						)}
						{React.isValidElement(ButtonEls) && ButtonEls}
					</div>
					{!isLastStep && (
						<Button variant="outlined" color="secondary" className="btn-minWidth next" onClick={() => onStepChange(currentStep + 1)}>
							下一步
						</Button>
					)}
				</div>
			</div>
		</React.Fragment>
	);
};

export default DocumentStepper;
